<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400 tx-12">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
          	<th><label class="ckbox mg-b-0 d-inline-block valign-middle">
	              <input type="checkbox"
              	:checked="isAll"
                @change="changeAllCheck($event)">
              <span></span>
            	</label>{{$t("transfer.客户信息")}}</th>
            <th>{{$t("transfer.转运单号")}}</th>
            <th>{{$t("transfer.创建时间")}}</th>
            <th>{{$t("transfer.包裹数量")}}</th>
            <th>{{$t("transfer.订单重(g)")}}</th>
            <th>{{$t("transfer.选择物流")}}</th>
            <th>{{$t("transfer.运费")}}</th>
            <th>{{$t("transfer.状态")}}</th>
            <th>{{$t("transfer.操作日志")}}</th>
            <th>{{$t("transfer.操作")}}</th>
          </tr>
        </thead>
        <tbody>
        	<tr v-for="(item, index) in items" :key="item.id+index">
        		<td class="valign-middle">
            	<label class="ckbox mg-b-0 d-inline-block valign-middle">
	              <input
                    type="checkbox"
                    :value="item.id"
                    v-model="checkArr"
                  >
	              <span></span>
	            </label>
            	<span class="tx-white">{{item.distributorName}}</span>
            </td>
            <td class="valign-middle">
            	<span class="tx-white">{{item.transCode}}</span>
            </td>
            <td class="valign-middle">
            	<span class="tx-white">{{item.timeCreated}}</span>
            </td>
            <td class="valign-middle">
            	<a v-if="item.cnt>0" href="javascript:;" class="tx-info" @click="openTransfer(item,'cnt')">{{item.cnt}}</a>
              <span v-else >---</span>
            </td>
            <td class="valign-middle">
             	<span class="tx-white">{{item.packageWeight}}</span>
            </td>
            <td class="valign-middle">
            	<template v-if="item.trackInfos && item.trackInfos.length">
            		<div v-for="track in item.trackInfos" :key="track.trackNumber" class="tx-white d-flex align-items-center">
            			{{item.logistics}}: 
            			<a href="javascript:;" @click="openTransTrack(track)" class="mg-r-5 tx-info">{{track.trackNumber}}</a>
            		</div>
            	</template>
              <template v-else>
            		<div class="tx-white">{{item.logistics}}: {{item.transTrackNumber}}</div>
            	</template>
             	<div>
             		 {{$t("transfer.实际物流渠道：")}}
              	<span v-show="item.realLogistics !=''" class="tx-white">{{item.realLogistics?item.realLogistics:'---'}}</span>
             	</div>
             	<div>
             		 {{$t("transfer.合作物流渠道：")}}
              	<span v-show="item.platform !=''" class="tx-white">{{item.platformName?item.platformName:'---'}}</span>
             	</div>
            </td>
            <td class="valign-middle">
              <span class="tx-white">￥{{item.shippingFee}}</span>
            </td>
            <td class="valign-middle">
            	<span  :class="item.status | statusClass">{{$t($dict.transferAboardStatus[item.status])}}</span>
            </td>
            <td class="valign-middle">
            	<a v-if="item.operateLog" href="javascript:;" @click="openLog(index)">
            		<i class="icon ion-chatbox-working tx-20 tx-info"></i>
            	</a>
            	<a v-else href="javascript:;">
            		<i class="icon ion-chatbox-working tx-20 tx-gray-600"></i>
            	</a>
            </td>
            <td class="valign-middle">
            	<!--<p class="mg-b-5">
            		<a href="javascript:;" class="tx-info" @click="openTransfer(item)">{{$t("transfer.填写发货信息")}}</a>
            	</p>-->
            	<p class="mg-b-5" v-if="item.status == 2">
            		<a href="javascript:;" class="tx-info" @click="setPackage(item,'3')">{{$t("transfer.设为已打包")}}</a>
            	</p>
            	<p class="mg-b-5" v-if="item.status == 1">
            		<a href="javascript:;" class="tx-info" @click="setPackage(item,'2')">{{$t("transfer.设为已付款")}}</a>
            	</p>
            	<p class="mg-b-5" v-if="item.status > 1 && item.status != 9">
            		<a href="javascript:;" class="tx-info" @click="openTransfer(item,'edit')">{{$t("transfer.修改转运信息")}}</a>
            	</p>
            	<p class="mg-b-0" v-if="item.status == 1">
            		<a href="javascript:;" class="tx-danger" @click="cancel(item)">{{$t("transfer.作废")}}</a>
            	</p>
            </td>
          </tr>
        </tbody>
        <tbody v-if="(!items || items.length < 1) && !first_loading">
          <tr>
            <td colspan="10">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{$t("transfer.没有符合条件的数据")}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["items", "first_loading","check_arr"],
  data() {
    return {
    	checkArr: [],
    };
  },
  computed: {
  	isAll() {
      return this.checkArr.length == this.items.length &&
        this.items.length > 0
        ? true
        : false;
    }
  },
  watch: {
  	check_arr: function() {
      this.checkArr = this.check_arr;
    },
    checkArr: function() {
      this.$emit("changeChecked",this.checkArr);
    },
  },
  filters: {
    statusClass(val) {
      if (!val) return;
      let className = "";
      switch (val) {
        case "1":
          className = "tx-warning";
          break;
        case "2":
          className = "tx-success";
          break;
        case "3":
          className = "tx-success";
          break;
        case "4":
          className = "tx-primary";
          break;
        case "8":
          className = " tx-danger";
          break;
        case "9":
          className = " tx-white-4";
          break;
      }
      return className;
    },
    formatDate(val) {
      if(!val) return '----';
      return moment(val, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD");
    }
  },
  methods: {
  	openTransTrack(item){
  		this.$emit("openTransTrack",item)
  	},
  	changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach(e => {
          this.checkArr.push(e.id);
        });
      }
    },
  	cancel(item){
  		this.$emit("cancel",item)
  	},
  	setPackage(item,type){
  		this.$emit("setPackage",item,type)
  	},
  	openTransfer(item,type){
  		this.$emit("openTransfer",item,type)
  	},
  	openLog(i){
  		this.$emit("openLog",i);
  	},
  }
};
</script>

